import styled from "styled-components";

export const SetSwitcherScore = styled.span`
  display: flex;
  align-items: center;
  padding-left: 6px;
  font-size: 12pt;

  @media (max-width: 700px) {
    font-size: 11pt;
  }
  @media (max-width: 600px) {
    font-size: 10pt;
  }

  @media (max-width: 500px) {
    font-size: 9pt;
  }
`;
